import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { PaginationModule } from "ngx-bootstrap/pagination";
import { DetailInfoFormPageStepComponent } from "./detail-info-form-page-step/detail-info-form-page-step.component";
import { DetailInfoFormPageStepsComponent } from "./detail-info-form-page-steps.component";
import { DetailInfoListModule } from "shared/detail-info-list/detail-info-list.module";
import { ArchwizardModule } from "@app/external/angular-archwizard";
import { FormVariantSelectorModule } from "shared/form-variant-selector/form-variant-selector.module";

@NgModule({
  declarations: [DetailInfoFormPageStepsComponent, DetailInfoFormPageStepComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ArchwizardModule,
    PaginationModule.forRoot(),
    DetailInfoListModule,
    FormVariantSelectorModule
  ],
  exports: [DetailInfoFormPageStepsComponent],
  providers: []
})

export class DetailInfoFormPageStepsModule { }